/* Appsalon: success popup for Swish Wishlist buttons on product cards. */
(function () {
  if (window.AppsalonWishlistPopupLoaded) return;
  window.AppsalonWishlistPopupLoaded = true;

  const PRODUCT_CARD_SELECTOR = [
    '.product-item',
    '[data-js-product-item]',
    '.product-card',
    '[data-product-card]',
    'wishlist-product-card',
    '.wk-product-card'
  ].join(',');

  const WISHLIST_BUTTON_SELECTORS = [
    '[data-wk-add-product]',
    '[data-wk-remove-product]',
    '[data-wishlist-button]',
    '[data-wishlist-add]',
    '[data-wishlist-toggle]',
    '[data-swish-wishlist]',
    '[class*="wk-button"]',
    '[class*="wk-wishlist-button"]',
    '[class*="wishlist-button"]',
    'button[aria-label*="wishlist" i]',
    'button[aria-label*="ønskeliste" i]',
    'button[aria-label*="onskeliste" i]',
    'a[aria-label*="wishlist" i]',
    'a[aria-label*="ønskeliste" i]',
    'a[aria-label*="onskeliste" i]'
  ].join(',');

  const HEADER_WISHLIST_SELECTORS = [
    '.wk-floating-button',
    '.wk-floating-link',
    '.wk-link',
    'a[href*="wishlist" i]',
    'button[aria-label*="wishlist" i]',
    'a[aria-label*="ønskeliste" i]',
    'button[aria-label*="ønskeliste" i]'
  ].join(',');

  let popupTimer = null;
  let lastPopupAt = 0;

  function getSettings() {
    const settings = window.KROWN && window.KROWN.settings ? window.KROWN.settings : {};

    return {
      type: settings.wishlist_success_animation || 'wishlist_popup',
      duration: parseInt(settings.wishlist_popup_duration, 10) || 2000
    };
  }

  function isVisible(element) {
    if (!element || !element.getBoundingClientRect) return false;

    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom >= 0 &&
      rect.top <= window.innerHeight &&
      style.visibility !== 'hidden' &&
      style.display !== 'none' &&
      style.opacity !== '0'
    );
  }

  function findWishlistButtonFromEvent(event) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];

    for (const item of path) {
      if (!item || item === window || item === document) continue;
      if (!(item instanceof Element)) continue;

      if (item.matches(WISHLIST_BUTTON_SELECTORS)) return item;

      const closestButton = item.closest(WISHLIST_BUTTON_SELECTORS);
      if (closestButton) return closestButton;
    }

    if (event.target && event.target.closest) {
      return event.target.closest(WISHLIST_BUTTON_SELECTORS);
    }

    return null;
  }

  function isProductCardWishlistButton(button) {
    if (!button) return false;
    return Boolean(button.closest(PRODUCT_CARD_SELECTOR));
  }

  function hasActiveWishlistState(button) {
    if (!button) return false;

    const elements = [button].concat(Array.from(button.querySelectorAll('*')));

    return elements.some(element => {
      const ariaPressed = element.getAttribute('aria-pressed');
      const ariaSelected = element.getAttribute('aria-selected');
      const dataState = [
        element.getAttribute('data-state'),
        element.getAttribute('data-status'),
        element.getAttribute('data-wk-state'),
        element.getAttribute('data-wishlist-state'),
        element.getAttribute('aria-label'),
        element.getAttribute('title')
      ].filter(Boolean).join(' ').toLowerCase();

      const className = typeof element.className === 'string' ? element.className.toLowerCase() : '';

      return (
        ariaPressed === 'true' ||
        ariaSelected === 'true' ||
        element.hasAttribute('checked') ||
        /(^|\s)(active|is-active|selected|is-selected|added|is-added|saved|is-saved|wk-active|wk-selected|wk-added)(\s|$)/.test(className) ||
        dataState.includes('remove') ||
        dataState.includes('fjern') ||
        dataState.includes('added') ||
        dataState.includes('saved') ||
        dataState.includes('selected') ||
        dataState.includes('i ønskelisten') ||
        dataState.includes('i onskelisten')
      );
    });
  }

  function getCartTrigger() {
    const selectors = [
      '.button--cart-handle',
      '.mobile-cart-button',
      '[aria-controls="site-cart-sidebar"]',
      'a[href$="/cart"]',
      'a[href*="/cart?"]'
    ].join(',');

    const candidates = Array.from(document.querySelectorAll(selectors));
    return candidates.find(isVisible) || candidates[0] || null;
  }

  function getHeaderWishlistTrigger(sourceButton) {
    const candidates = Array.from(document.querySelectorAll(HEADER_WISHLIST_SELECTORS));

    return candidates.find(element => {
      if (sourceButton && element === sourceButton) return false;
      if (sourceButton && sourceButton.contains(element)) return false;
      if (element.closest(PRODUCT_CARD_SELECTOR)) return false;
      return isVisible(element);
    }) || null;
  }

  function pulseElement(element) {
    if (!element) return;

    element.classList.remove('appsalon-cart-pulse');
    void element.offsetWidth;
    element.classList.add('appsalon-cart-pulse');

    window.setTimeout(() => {
      element.classList.remove('appsalon-cart-pulse');
    }, 900);
  }

  function positionPopup(popup, anchor) {
    popup.style.visibility = 'hidden';
    popup.classList.remove('is-visible');
    popup.style.removeProperty('right');
    popup.style.removeProperty('bottom');

    const popupWidth = popup.offsetWidth || 260;
    const popupHeight = popup.offsetHeight || 48;
    const margin = 12;
    let top = margin;
    let left = window.innerWidth - popupWidth - margin;

    if (anchor && anchor.getBoundingClientRect) {
      const rect = anchor.getBoundingClientRect();

      if (rect.width > 0 && rect.height > 0) {
        top = rect.bottom + 10;
        left = rect.right - popupWidth;
      }
    }

    top = Math.max(margin, Math.min(top, window.innerHeight - popupHeight - margin));
    left = Math.max(margin, Math.min(left, window.innerWidth - popupWidth - margin));

    popup.style.top = `${top}px`;
    popup.style.left = `${left}px`;
    popup.style.visibility = '';
  }

  function showWishlistPopup(sourceButton, options = {}) {
    const settings = getSettings();
    if (settings.type === 'none') return;

    const now = Date.now();
    if (!options.force && now - lastPopupAt < 250) return;
    lastPopupAt = now;

    const headerWishlistTrigger = getHeaderWishlistTrigger(sourceButton);
    const anchor = headerWishlistTrigger || sourceButton || getCartTrigger();

    pulseElement(headerWishlistTrigger || sourceButton || getCartTrigger());

    let popup = document.querySelector('[data-appsalon-wishlist-popup]');
    if (!popup) {
      popup = document.createElement('div');
      popup.setAttribute('data-appsalon-wishlist-popup', '');
      popup.className = 'appsalon-quick-buy-popup appsalon-wishlist-popup';
      popup.setAttribute('role', 'status');
      popup.setAttribute('aria-live', 'polite');
      document.body.appendChild(popup);
    }

    popup.innerHTML = `
      <span class="appsalon-quick-buy-popup__icon appsalon-wishlist-popup__icon" aria-hidden="true">♥</span>
      <span class="appsalon-quick-buy-popup__text">Lagt i ønskelisten</span>
    `;

    positionPopup(popup, anchor);

    void popup.offsetWidth;
    popup.classList.add('is-visible');

    window.clearTimeout(popupTimer);
    popupTimer = window.setTimeout(() => {
      popup.classList.remove('is-visible');
    }, Math.max(1000, parseInt(options.duration || settings.duration, 10) || 2000));
  }

  function handleWishlistClick(event) {
    const settings = getSettings();
    if (settings.type === 'none') return;

    const button = findWishlistButtonFromEvent(event);
    if (!button || !isProductCardWishlistButton(button)) return;

    const wasActive = hasActiveWishlistState(button);

    window.setTimeout(() => {
      // If it was already active before the click, the click was most likely a remove action.
      // Do not show "Lagt i ønskelisten" for removes.
      if (wasActive) return;

      showWishlistPopup(button, { duration: settings.duration });
    }, 350);
  }

  // Fallback for normal Swish button clicks in the theme DOM.
  document.addEventListener('click', handleWishlistClick, true);

  // If Swish/Wishlist King exposes DOM custom events, this catches successful add events too.
  // The app's own docs use the event name wk:wishlist:add:success inside their code editor.
  [
    'wk:wishlist:add:success',
    'wishlist:add:success',
    'swish:wishlist:add:success'
  ].forEach(eventName => {
    document.addEventListener(eventName, event => {
      const source = event.target instanceof Element ? event.target : null;
      showWishlistPopup(source, { force: true });
    });
  });

  window.AppsalonWishlistPopup = {
    show: showWishlistPopup
  };
})();
